import React from 'react';

function CustomIcon({ width = 24, height = 24, className = "", color }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} viewBox="0 0 14.771 14">
            <path
                id="Vector_-_2025-02-10T181555.446"
                data-name="Vector - 2025-02-10T181555.446"
                d="M3.483,0A1.981,1.981,0,0,0,2.177.476a1.533,1.533,0,0,0-.541,1.149V3.833a3.077,3.077,0,0,1,.71-.083H5.084a2.9,2.9,0,0,1,1.908.7l3.754,3.3h1.4V1.625A1.533,1.533,0,0,0,11.606.476,1.981,1.981,0,0,0,10.3,0ZM14.135,7.833a3.077,3.077,0,0,0-.71-.083H13V1.875a1.816,1.816,0,0,1,.826.6,1.49,1.49,0,0,1,.31.9ZM.5,6.125a1.533,1.533,0,0,1,.541-1.149A1.982,1.982,0,0,1,2.346,4.5H5.084a1.981,1.981,0,0,1,1.306.476l3.8,3.341a.765.765,0,0,0,.5.183h2.737a1.981,1.981,0,0,1,1.306.476,1.533,1.533,0,0,1,.541,1.149V11.75a2.123,2.123,0,0,1-.749,1.591A2.744,2.744,0,0,1,12.715,14H3.057a2.744,2.744,0,0,1-1.808-.659A2.123,2.123,0,0,1,.5,11.75Z"
                transform="translate(-0.5)"
                fill="currentcolor"
            />
        </svg>
    );
}

export default CustomIcon;
